module.exports = __webpack_public_path__ + "static/media/imagentienda_2x.2fb42579.png";